import PortableTextPlus from "@/components/portable-text-plus";
import CallToActionButton from "@/components/call-to-action-button";
import WhatsAppButton from "@/components/whatsapp-button";
import SegmentContainer from "./segment-container";
import classNames from "classnames";

export const Filter = ({ fromColorHex, toColorHex }) => {
  return (
    <div
      className="absolute inset-0 opacity-50"
      style={{
        background: `linear-gradient(to right, ${fromColorHex}, ${toColorHex})`,
      }}
    />
  );
};

export default function HeroSingleBlock({ segment, ...props }) {
  const callToActions = segment.block.callToActions;
  const isContactUsButton = (callToAction) =>
    callToAction.title.includes("Contact us");

  return (
    <>
      <div
        style={{ ...props.bgImageStyle, ...props.bgColorStyle }}
        className={classNames(
          "relative h-[280px] bg-cover bg-left sm:bg-center shadow",
          segment.isTall
            ? "sm:h-[75vh] sm:max-h-[810px] 2xl:max-h-[60vh]"
            : "sm:h-[50vh] sm:max-h-[540px] lg:h-[60vh] 2xl:max-h-[45vh]"
        )}
      >
        {segment.bgFilter && (
          <Filter
            fromColorHex={segment.bgFilterFromColorHex}
            toColorHex={segment.bgFilterToColorHex}
          />
        )}

        <SegmentContainer
          className={`${props.paddingClasses} text-center sm:text-left h-full`}
        >
          <div className="w-full sm:max-w-[61.8%] xl:max-w-[50%]">
            <div
              className={classNames(
                "text-2xl sm:text-3xl md:text-4xl xl:text-4.5xl font-semibold",
                "leading-snug sm:leading-snug xl:leading-tight whitespace-pre-line"
              )}
            >
              <PortableTextPlus value={segment.block.heading} />
            </div>

            {segment.block.content && (
              <div className="hidden sm:block md:text-lg 2xl:text-xl mt-6 space-y-6 sm:leading-snug prose">
                <PortableTextPlus value={segment.block.content} />
              </div>
            )}
            {callToActions &&
              callToActions.map((callToAction) => (
                <div key={callToAction._key} className="mt-6 sm:mt-12">
                  {isContactUsButton(callToAction) ? (
                    <WhatsAppButton
                      className="sm:hidden"
                      href={callToAction.url}
                    >
                      {callToAction.title}
                    </WhatsAppButton>
                  ) : (
                    <CallToActionButton
                      href={callToAction.url}
                      newTab={true}
                      className="hidden sm:block lg:w-64"
                      {...callToAction}
                    >
                      {callToAction.title}
                    </CallToActionButton>
                  )}
                </div>
              ))}
          </div>
          {callToActions &&
            callToActions.map(
              (callToAction) =>
                isContactUsButton(callToAction) && (
                  <WhatsAppButton
                    key={callToAction._key}
                    className="hidden sm:block sm:absolute sm:right-8 sm:bottom-8 lg:right-6 lg:bottom-6"
                    href={callToAction.url}
                  >
                    {callToAction.title}
                  </WhatsAppButton>
                )
            )}
        </SegmentContainer>
      </div>

      {/* Mobile Only */}
      {(segment.block.content || callToActions) && (
        <SegmentContainer className="block sm:hidden py-10 text-center bg-white">
          {segment.block.content && (
            <div className="leading-snug space-y-6 prose">
              <PortableTextPlus value={segment.block.content} />
            </div>
          )}
          {callToActions &&
            callToActions.map(
              (callToAction) =>
                !isContactUsButton(callToAction) && (
                  <div key={callToAction._key} className="mt-8">
                    <CallToActionButton href={callToAction.url}>
                      {callToAction.title}
                    </CallToActionButton>
                  </div>
                )
            )}
        </SegmentContainer>
      )}
    </>
  );
}
